import productCardIni from "../cookieStorage/productCardIni.js";
import store from "../store";
import {fetchVisitorByUUID} from "../reduxLib/visitorLib";
import {
    addItemToShoppingCard,
    fetchShoppingCardByVisitorRelID,
    removeItemFromShoppingCard
} from "../reduxLib/shoppingcardLib";

function addToCart(product,qt) {
    const cart = productCardIni();

    console.log("addToCart called with product:", product, "and quantity:", qt);

    const qty = Math.max(1, Number(qt) || 1);
    const productId = product.id ?? product.productID;

    const idx = cart.findIndex(p =>
        p.id === productId &&
        p.color === product.color &&
        p.textile === product.textile &&
        p.plexis === product.plexis &&
        p.closing === product.closing
    );

    if (idx >= 0) {
        cart[idx].quantity += qty;
    } else {
        cart.push({
            id: productId,
            name: product.name,
            image: product.image,
            price: product.price,
            description: product.description,

            color: product.color,
            textile: product.textile,
            plexis: product.plexis,
            closing: product.closing,

            quantity: qty
        });
    }

    localStorage.setItem("productCard", JSON.stringify(cart));

    store
        .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
        .unwrap()
        .then(visitor => {
            console.log("Visitor:", visitor);
            return store
                .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                .unwrap();
        })
        .then(shoppingCard => {
            console.log("ShoppingCard:", shoppingCard);

            const itemToAdd = {
                productId: productId,
                productName: product.name,
                image: product.image,
                price: product.price,

                colorId: product.color,
                textiles: product.textile,
                plexis: product.plexis,
                closingTextiles: product.closing,
            };

            return store
                .dispatch(
                    addItemToShoppingCard({
                        cardId: shoppingCard.shoppingCardId,
                        item: itemToAdd,
                        quantity: qty
                    })
                )
                .unwrap();
        })
        .then(result => {
            console.log("AddItem result:", result);
        })
        .catch(err => {
            console.error("ERROR:", err);
        });
}

export default addToCart;
